namespace RedBullMOBILE360.Web.API {
    export namespace ITGService {
        export const baseUrl = '~/api/ITG';

        export declare function GetCVMWhitelistOffers(request: string, onSuccess?: (response: string[]) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function FetchOffersAsync(request: string, onSuccess?: (response: string[]) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            GetCVMWhitelistOffers = "~/api/ITG/GetCVMWhitelistOffers",
            FetchOffersAsync = "~/api/ITG/FetchOffersAsync"
        }

        [
            'GetCVMWhitelistOffers', 
            'FetchOffersAsync'
        ].forEach(x => {
            (<any>ITGService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
